import _lowerFirst from "lodash/lowerFirst";
import _isString from "lodash/isString";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import * as React from 'react';
import { IconCheck, IconCloseThin } from '../Icons';
import classnames from 'classnames';
import FormError from '../FormError';
import FormHint from '../FormHint';
import FormLabel from '../FormLabel';
import FormSuccess from '../FormSuccess';
import injectStyles from '../jss';
import styles from './FieldContainer.jss';
export var FieldContainer = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FieldContainer, _React$PureComponent);
  function FieldContainer() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, FieldContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FieldContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      focused: false
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleBlur", function () {
      _this.setState({
        focused: false
      });
    });
    return _this;
  }
  _createClass(FieldContainer, [{
    key: "renderIndicator",
    value: function renderIndicator() {
      var _this$props = this.props,
        classes = _this$props.classes,
        error = _this$props.error,
        success = _this$props.success,
        hasIndicator = _this$props.hasIndicator;
      var Icon = error ? IconCloseThin : IconCheck;
      if (!hasIndicator || !(error || success)) {
        return null;
      }
      return React.createElement("div", {
        className: classnames(classes.indicator, error && classes.indicator__error)
      }, React.createElement(Icon, null));
    }
  }, {
    key: "renderLabel",
    value: function renderLabel() {
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        error = _this$props2.error,
        errorWithLabel = _this$props2.errorWithLabel,
        floatingLabel = _this$props2.floatingLabel,
        hideFieldName = _this$props2.hideFieldName,
        label = _this$props2.label,
        labelClass = _this$props2.labelClass,
        labelRef = _this$props2.labelRef,
        name = _this$props2.name,
        optional = _this$props2.optional,
        simplified = _this$props2.simplified,
        success = _this$props2.success,
        value = _this$props2.value;
      var focused = this.state.focused;
      var notEmptyValue = value === 0 || String(value || '').length;
      var positioned = error || success || notEmptyValue || focused;
      var lowerCasedError = _isString(error) ? _lowerFirst(error) : null;
      var displayedError = !simplified && errorWithLabel && lowerCasedError || '';
      var children = typeof label === 'string' ? "".concat(label, " ").concat(displayedError) : [label, displayedError];
      var errorToRender = typeof label === 'string' ? displayedError : [displayedError];
      if (!label && !error) {
        return null;
      }
      return React.createElement(FormLabel, {
        error: error,
        name: name,
        optional: optional,
        labelRef: labelRef,
        floating: floatingLabel,
        positioned: floatingLabel && !simplified && positioned,
        className: classnames(simplified && classes.label__simplified, labelClass)
      }, hideFieldName ? errorToRender : children);
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2, _classnames3;
      var _this$props3 = this.props,
        autoHeight = _this$props3.autoHeight,
        bordered = _this$props3.bordered,
        borderRight = _this$props3.borderRight,
        bottomMargin = _this$props3.bottomMargin,
        children = _this$props3.children,
        wrapperRef = _this$props3.wrapperRef,
        classes = _this$props3.classes,
        classNameProp = _this$props3.className,
        disabled = _this$props3.disabled,
        error = _this$props3.error,
        errorLabelClass = _this$props3.errorLabelClass,
        errorWithLabel = _this$props3.errorWithLabel,
        hint = _this$props3.hint,
        onClick = _this$props3.onClick,
        padded = _this$props3.padded,
        simplified = _this$props3.simplified,
        topMargin = _this$props3.topMargin,
        width = _this$props3.width,
        success = _this$props3.success,
        successfulActionMessage = _this$props3.successfulActionMessage;
      var focused = this.state.focused;
      if (simplified) {
        var _classnames;
        var className = classnames((_classnames = {}, _defineProperty(_classnames, classes.container__topMargin, topMargin), _defineProperty(_classnames, classes.container__bottomMargin, bottomMargin), _defineProperty(_classnames, "errorMessage", error), _classnames), classNameProp);
        return React.createElement("div", {
          className: className,
          onClick: onClick
        }, this.renderLabel(), children, React.createElement(FormError, {
          className: errorLabelClass
        }, error), React.createElement(FormHint, null, hint), success && successfulActionMessage && React.createElement(FormSuccess, null, successfulActionMessage));
      }
      return React.createElement("div", {
        className: classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.container__topMargin, topMargin), _defineProperty(_classnames2, classes.container__bottomMargin, bottomMargin), _classnames2), classNameProp),
        onClick: onClick
      }, React.createElement("div", {
        className: classnames((_classnames3 = {}, _defineProperty(_classnames3, classes.wrapper, true), _defineProperty(_classnames3, classes.wrapper__bordered, bordered), _defineProperty(_classnames3, classes.wrapper__borderRight, !bordered && borderRight), _defineProperty(_classnames3, classes.wrapper__disabled, disabled), _defineProperty(_classnames3, classes.wrapper__error, error), _defineProperty(_classnames3, classes.wrapper__focused, focused), _defineProperty(_classnames3, classes.wrapper__padded, padded), _defineProperty(_classnames3, classes.wrapper__autoHeight, autoHeight), _defineProperty(_classnames3, classes["wrapper__".concat(width)], width), _defineProperty(_classnames3, "errorMessage", error), _classnames3)),
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        ref: wrapperRef
      }, this.renderLabel(), children, this.renderIndicator()), !errorWithLabel && React.createElement(FormError, {
        className: errorLabelClass
      }, error), success && successfulActionMessage && React.createElement(FormSuccess, null, successfulActionMessage), React.createElement(FormHint, null, hint));
    }
  }]);
  return FieldContainer;
}(React.PureComponent);
_defineProperty(FieldContainer, "styleRoot", 'FieldContainer');
_defineProperty(FieldContainer, "defaultProps", {
  bottomMargin: true,
  errorWithLabel: true,
  floatingLabel: true,
  hasIndicator: true,
  topMargin: true,
  width: 'medium'
});
export default injectStyles(styles)(FieldContainer);